var exports = {
  "Sr": "Pagination.module__paginationBar___STliem",
  "_s": "Pagination.module__paginationWrapper___STliem",
  "gc": "Pagination.module__pageButton___STliem",
  "Ks": "Pagination.module__pageButtonActive___STliem",
  "oq": "Pagination.module__ellipsisButton___STliem",
  "kh": "Pagination.module__pageInputForm___STliem",
  "aW": "Pagination.module__pageInputLabel___STliem",
  "AU": "Pagination.module__pageInput___STliem",
  "Mp": "Pagination.module__focusRingCircular___STliem",
};

module.exports = exports;
